import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

/**
 * CollapsibleSection, single-column accordion section used to keep dense pages
 * scannable. Header (icon + title) is always visible; body expands on click.
 */
export default function CollapsibleSection({ icon: Icon, title, accent = 'text-blue-400', defaultOpen = false, testId, right = null, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div id={testId} className="rounded-xl border border-white/10 bg-slate-900/50 backdrop-blur-xl overflow-hidden scroll-mt-24" data-testid={testId}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 px-5 py-4 hover:bg-white/[0.03] transition-colors"
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        <span className="flex items-center gap-3 min-w-0">
          {Icon && (
            <span className={`w-9 h-9 rounded-lg bg-white/5 ring-1 ring-white/10 flex items-center justify-center ${accent}`}>
              <Icon className="w-5 h-5" />
            </span>
          )}
          <span className="font-outfit text-base sm:text-lg font-semibold text-white text-left truncate">{title}</span>
        </span>
        <span className="flex items-center gap-3 flex-shrink-0">
          {right}
          <ChevronDown className={`w-5 h-5 text-slate-300 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            <div className="px-5 pb-5 pt-1">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
